export * from './property.service';
export * from './property';
